import { Switch } from '@mantine/core';

export const SwitchResolver = Switch.extend({
  styles: {
    track: {
      boxSizing: 'border-box',
    },
    thumb: {
      boxSizing: 'border-box',
    },
  },
});
